import { lazyTriggerResizeEvent } from 'owa-resize-event';
import { closeFlexPane, openFlexPane } from 'owa-suite-header-apis';
import { orchestrator } from 'satcheljs';

export const openFlexPaneMutator = orchestrator(openFlexPane, actionMessage => {
    lazyTriggerResizeEvent.importAndExecute();
});

export const closeFlexPaneMutator = orchestrator(closeFlexPane, actionMessage => {
    lazyTriggerResizeEvent.importAndExecute();
});
